import posthog from 'posthog-js';

const token = import.meta.env.VITE_POSTHOG_TOKEN;
const host = import.meta.env.VITE_POSTHOG_HOST;

export function initPostHog(): void {
  if (import.meta.env.VITE_NODE_ENV === 'development' || !token) {
    return;
  }

  if (!host) {
    return;
  }

  posthog.init(token, {
    api_host: host,
    autocapture: false,
    capture_pageview: 'history_change',
    capture_pageleave: false,
    person_profiles: 'identified_only',
  });
}

export function identifyUser(
  userId: number,
  companyId: number,
  isAdmin: boolean,
): void {
  posthog.identify(String(userId), {
    is_admin: isAdmin,
    company_id: companyId,
  });

  posthog.register({
    user_id: userId,
    company_id: companyId,
    is_admin: isAdmin,
  });

  posthog.group('company', String(companyId));
}

export function resetUser(): void {
  posthog.reset();
}

export function captureEvent(
  event: string,
  properties: Record<string, unknown> = {},
): void {
  posthog.capture(event, properties);
}
